/* ---------------------------------------------------------------------------
   ASSOTS BUNDLE SLOT KEYS

   _bundle_slot used to store the slot's DISPLAY LABEL, e.g. "Choose Your
   Strap". Renaming that label in the theme editor changed what was written
   into the cart, and every consumer that matched on the old string silently
   stopped working. That is what broke the cart drawer placeholders and, later,
   the gift picker.

   It now stores a stable key: slot_1, slot_2, slot_3. Labels can be renamed
   freely and nothing downstream notices.

   ASL_SLOT_ALIASES lets any historic value resolve to its stable key, so carts
   created before this change still work.
--------------------------------------------------------------------------- */
window.ASL_SLOT_KEYS = ['slot_1', 'slot_2', 'slot_3'];

window.ASL_SLOT_ALIASES = {
  slot_1: ['slot_1', 'Select Free Strap', 'Choose Your Strap', 'auto_gift_1'],
  slot_2: ['slot_2', 'Select Free Keyring / Key Pod Case', 'Select Free Keyring', 'Choose Your Keyring', 'Choose Your Keyring or Case', 'auto_gift_2'],
  slot_3: ['slot_3', 'Select Free Card Holder', 'Choose Your Card Holder', 'auto_gift_3']
};

/* Returns the stable key for any known slot value, or the value unchanged.
   Unknown values pass through untouched so fixed gifts and 'main' are safe. */
window.aslSlotKey = function (value) {
  const raw = String(value == null ? '' : value).trim();
  if (!raw) return raw;
  const keys = Object.keys(window.ASL_SLOT_ALIASES);
  for (let i = 0; i < keys.length; i++) {
    const list = window.ASL_SLOT_ALIASES[keys[i]];
    for (let j = 0; j < list.length; j++) {
      if (list[j].toLowerCase() === raw.toLowerCase()) return keys[i];
    }
  }
  return raw;
};

/* True when a slot is one of the three customer-selectable ones. */
window.aslIsSelectableSlot = function (value) {
  return window.ASL_SLOT_KEYS.indexOf(window.aslSlotKey(value)) !== -1;
};

/* The gift picker's product lists are keyed by the old labels. Mirror them
   onto the stable keys so lookups work whichever value a cart line carries. */
window.aslAliasGiftCollections = function () {
  const c = window.cartGiftModalCollections;
  if (!c) return;
  Object.keys(window.ASL_SLOT_ALIASES).forEach((key) => {
    if (c[key]) return;
    const match = window.ASL_SLOT_ALIASES[key].find((alias) => c[alias]);
    if (match) c[key] = c[match];
  });
};

/* Cart calls keep the shopper's market (/en-us/cart/add.js and so on). The root
   form can answer from another market's context. */
window.aslCartUrl = function (path) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root + path;
};

/* The Swap pop-up's choices load the first time they are needed, from
   sections/assots-gift-lists.liquid, in the shopper's market. A failed load is
   forgotten so the next tap tries again. */
window.aslLoadGiftLists = function () {
  if (window.aslGiftListsPromise) return window.aslGiftListsPromise;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  window.aslGiftListsPromise = fetch(root + '?section_id=assots-gift-lists')
    .then((res) => {
      if (!res.ok) throw new Error('Gift lists returned ' + res.status);
      return res.text();
    })
    .then((html) => {
      const data = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-asl-gift-lists]');
      if (!data) throw new Error('Gift lists not found');
      window.cartGiftModalCollections = JSON.parse(data.textContent);
      window.aslAliasGiftCollections();
      // The second strap of choice from the gift set uses the same strap list.
      window.cartGiftModalCollections.slot_4 = window.cartGiftModalCollections.slot_1;
      return window.cartGiftModalCollections;
    })
    .catch((error) => {
      window.aslGiftListsPromise = null;
      throw error;
    });
  return window.aslGiftListsPromise;
};

document.addEventListener('DOMContentLoaded', function () {
  const productItems = document.querySelectorAll('.ProductItem');
  productItems.forEach(function (productItem) {
    const mainImage = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    const colorSwatches = productItem.querySelectorAll('.ColorSwatch[data-swatch-image-url]');
    if (!mainImage || colorSwatches.length === 0) return;
    // Store original image data
    const originalImageData = {
      src: mainImage.getAttribute('data-src') || mainImage.src,
      widths: mainImage.getAttribute('data-widths'),
      aspectRatio: mainImage.style.getPropertyValue('--aspect-ratio') || mainImage.getAttribute('data-aspect-ratio'),
      mediaId: mainImage.getAttribute('data-media-id')
    };
    colorSwatches.forEach(function (swatch) {
      swatch.addEventListener('mouseenter', function () {
        const swatchImageUrl = this.getAttribute('data-swatch-image-url');
        const swatchImageWidths = this.getAttribute('data-swatch-image-widths');
        const swatchImageId = this.getAttribute('data-swatch-image-id');
        const swatchAspectRatio = this.getAttribute('data-swatch-image-aspect-ratio');
        if (swatchImageUrl) {
          // Update image attributes
          mainImage.setAttribute('data-src', swatchImageUrl);
          if (swatchImageWidths) mainImage.setAttribute('data-widths', swatchImageWidths);
          if (swatchImageId) mainImage.setAttribute('data-media-id', swatchImageId);
          // Update aspect ratio if available
          if (swatchAspectRatio) {
            const aspectRatioContainer = productItem.querySelector('.AspectRatio');
            if (aspectRatioContainer) {
              aspectRatioContainer.style.setProperty('--aspect-ratio', swatchAspectRatio);
            }
          }
          // Trigger lazy load update if LazySizes is available
          if (window.lazySizes) {
            window.lazySizes.rAF(function () {
              window.lazySizes.loader.unveil(mainImage);
            });
          } else {
            // Fallback: update src directly
            mainImage.src = swatchImageUrl.replace('{width}', '600');
          }
        }
      });
      swatch.addEventListener('mouseleave', function () {
        // Restore original image
        mainImage.setAttribute('data-src', originalImageData.src);
        if (originalImageData.widths) mainImage.setAttribute('data-widths', originalImageData.widths);
        if (originalImageData.mediaId) mainImage.setAttribute('data-media-id', originalImageData.mediaId);
        // Restore original aspect ratio
        if (originalImageData.aspectRatio) {
          const aspectRatioContainer = productItem.querySelector('.AspectRatio');
          if (aspectRatioContainer) {
            aspectRatioContainer.style.setProperty('--aspect-ratio', originalImageData.aspectRatio);
          }
        }
        // Trigger lazy load update if LazySizes is available
        if (window.lazySizes) {
          window.lazySizes.rAF(function () {
            window.lazySizes.loader.unveil(mainImage);
          });
        } else {
          // Fallback: update src directly
          mainImage.src = originalImageData.src.replace('{width}', '600');
        }
      });
    });
  });
  // Free Product Selector Countdown
  function initFreeProductCountdown() {
    const countdownElements = document.querySelectorAll('[data-countdown]');
    // console.log(`Free Product Countdown: Found ${countdownElements.length} countdown elements`);
    countdownElements.forEach((element, index) => {
      const daysEl = element.querySelector('[data-days]');
      const hoursEl = element.querySelector('[data-hours]');
      const minutesEl = element.querySelector('[data-minutes]');
      const secondsEl = element.querySelector('[data-seconds]');
      // console.log(`Free Product Countdown: Elements found for countdown ${index + 1}:`, {
      //   daysEl: !!daysEl,
      //   hoursEl: !!hoursEl,
      //   minutesEl: !!minutesEl,
      //   secondsEl: !!secondsEl
      // });
      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
        console.error('Free Product Countdown: Missing display elements');
        return;
      }
      // Get expiry timestamp from data attribute
      const expiryTimestamp = parseInt(element.dataset.expiry);
      if (!expiryTimestamp || isNaN(expiryTimestamp)) {
        console.error('Free Product Countdown: Invalid expiry timestamp:', expiryTimestamp);
        daysEl.textContent = 'ERROR';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }
      // console.log(`Free Product Countdown: Expiry timestamp: ${expiryTimestamp}`);
      function updateCountdown() {
        const currentTime = Math.floor(Date.now() / 1000);
        const timeRemaining = expiryTimestamp - currentTime;
        if (timeRemaining <= 0) {
          // Expired
          daysEl.textContent = '0';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          element.classList.add('expired');
          return false;
        }
        // Calculate time components
        const days = Math.floor(timeRemaining / 86400);
        const hours = Math.floor((timeRemaining % 86400) / 3600);
        const minutes = Math.floor((timeRemaining % 3600) / 60);
        const seconds = timeRemaining % 60;
        // Update display
        daysEl.textContent = days.toString();
        hoursEl.textContent = hours.toString().padStart(2, '0');
        minutesEl.textContent = minutes.toString().padStart(2, '0');
        secondsEl.textContent = seconds.toString().padStart(2, '0');
        // console.log(`Free Product Countdown: Updated - ${days}d ${hours}:${minutes}:${seconds}`);
        return true;
      }
      // Update immediately
      if (updateCountdown()) {
        // Update every second
        setInterval(() => {
          if (!updateCountdown()) {
            clearInterval(this);
          }
        }, 1000);
      }
    });
  }
  // Store original titles and images when page loads
  const originalSlotTitles = new Map();
  const originalSlotImages = new Map();
  // Initialize original titles and images storage
  function storeOriginalTitles() {
    const allButtons = document.querySelectorAll('.nx-free-product-selector__button');
    allButtons.forEach(button => {
      const key = `${button.dataset.slot}_${button.dataset.slotType}`;
      // Store original title
      const textSpan = button.querySelector('span.font-medium');
      if (textSpan && textSpan.textContent.trim()) {
        originalSlotTitles.set(key, textSpan.textContent.trim());
      }
      // Store original image data and visibility state
      const imageContainer = button.querySelector('.nx-free-product-selector__image');
      const img = button.querySelector('.nx-free-product-selector__image img');
      if (imageContainer && img) {
        originalSlotImages.set(key, {
          src: img.src,
          alt: img.alt,
          wasHidden: imageContainer.classList.contains('hidden') // Store original visibility state
        });
      }
    });
  }
  // Update Clear All button visibility based on selections
  function updateClearAllButton() {
    const selectedButtons = document.querySelectorAll('.nx-free-product-selector__button.selected');
    const clearAllButton = document.querySelector('[data-action="clear-all-selections"]');
    if (clearAllButton) {
      if (selectedButtons.length > 0) {
        clearAllButton.style.display = 'inline-block';
      } else {
        clearAllButton.style.display = 'none';
      }
    }
  }
  // Helper function to clear all selections
  function clearAllSelections() {
    const allButtons = document.querySelectorAll('.nx-free-product-selector__button');
    allButtons.forEach(button => {
      const wasSelected = button.classList.contains('selected');
      button.classList.remove('selected');
      // Remove selected product data
      if (button.dataset.selectedProductId) {
        delete button.dataset.selectedProductId;
      }
      // Reset button text and image for product list/collection buttons that were changed
      if ((button.dataset.slotType === 'product_list' || button.dataset.slotType === 'collection') && wasSelected) {
        const key = `${button.dataset.slot}_${button.dataset.slotType}`;
        // Restore original title
        const textSpan = button.querySelector('span.font-medium');
        if (textSpan) {
          const originalTitle = originalSlotTitles.get(key);
          if (originalTitle) {
            textSpan.textContent = originalTitle;
          }
        }
        // Restore original image and visibility
        const imageContainer = button.querySelector('.nx-free-product-selector__image');
        if (imageContainer) {
          const img = imageContainer.querySelector('img');
          const originalImage = originalSlotImages.get(key);
          if (originalImage && img) {
            img.src = originalImage.src;
            img.alt = originalImage.alt;
            // Restore original visibility state
            if (originalImage.wasHidden) {
              imageContainer.classList.add('hidden');
              imageContainer.classList.remove('block');
            } else {
              imageContainer.classList.remove('hidden');
              imageContainer.classList.add('block');
            }
          }
        }
      }
    });
    // console.log('🧹 Cleared all free product selections');
    // Update Clear All button visibility
    updateClearAllButton();
  }
  // Helper function to get selected free products
  function getSelectedFreeProducts() {
    const selectedButtons = document.querySelectorAll('.nx-free-product-selector__button.selected');
    return Array.from(selectedButtons).map(button => {
      let productId, title;
      if (button.dataset.slotType === 'single_product') {
        productId = button.dataset.productId;
        title = button.querySelector('span.font-medium')?.textContent || 'Unknown Product';
      } else if (button.dataset.slotType === 'product_list' || button.dataset.slotType === 'collection') {
        productId = button.dataset.selectedProductId;
        // Get the actual product title from the button text (which now shows the selected product name)
        title = button.querySelector('span.font-medium')?.textContent || 'Unknown Product';
      }
      return {
        productId: productId,
        slot: button.dataset.slot,
        title: title,
        type: button.dataset.slotType
      };
    }).filter(product => product.productId); // Only include products that have been selected
  }
  // Modal functions
  function openProductModal(slot, productList, originalButton) {
    const modal = document.getElementById('productSelectionModal');
    // Get slot title
    const slotTitle = originalButton.querySelector('span.font-medium')?.textContent || `Slot ${slot}`;
    // Create modal content dynamically
    modal.innerHTML = `
      <div class="nx-product-modal__content relative max-w-3xl w-full max-h-screen overflow-hidden flex flex-col">
        <div class="nx-product-modal__header flex items-center justify-between p-5">
          <h3 class="nx-product-modal__title Heading m-0">Select a Product for ${slotTitle}</h3>
          <button type="button" class="nx-product-modal__close bg-transparent border-0 cursor-pointer p-2 rounded" data-action="close-modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
            </svg>
          </button>
        </div>
        <div class="nx-product-modal__body p-5 overflow-y-auto">
          <div class="nx-product-modal__grid grid gap-5" id="modalProductGrid">
            <!-- Products will be populated here -->
          </div>
        </div>
      </div>
    `;
    // Get the modal grid after creating the content
    const modalGrid = document.getElementById('modalProductGrid');
    // Populate modal with products (only available ones)
    const availableProducts = productList.filter(product => {
      // console.log(`Product ${product.title}: available = ${product.available}`);
      return product.available === true;
    });
    // console.log(`Showing ${availableProducts.length} of ${productList.length} products (available only)`);
    if (availableProducts.length === 0) {
      modalGrid.innerHTML = '<p style="text-align: center; padding: 20px; color: #666;">No products available for selection</p>';
      return;
    }
    availableProducts.forEach(product => {
      const productItem = document.createElement('div');
      productItem.className = 'ProductItem nx-product-modal__item cursor-pointer overflow-hidden relative';
      productItem.dataset.productId = product.id;
      productItem.dataset.productTitle = product.title;
      productItem.dataset.slot = slot;
      // Better image URL handling
      let imageUrl = '';
      if (product.featured_media && product.featured_media.preview_image) {
        // Try different image URL formats
        if (product.featured_media.preview_image.src) {
          imageUrl = product.featured_media.preview_image.src;
          // Replace with Shopify image transform
          imageUrl = imageUrl.replace(/\.(jpg|jpeg|png|gif|webp|JPG|JPEG|PNG|GIF|WEBP)$/, '_400x400.$1');
        } else if (product.featured_image) {
          imageUrl = product.featured_image;
        }
      } else if (product.featured_image) {
        imageUrl = product.featured_image;
      }
      // console.log('Product data structure:', product);
      // console.log('Product:', product.title, 'Image URL:', imageUrl);
      // Fallback: try simpler image URL construction
      if (!imageUrl && product.images && product.images.length > 0) {
        imageUrl = product.images[0];
      }
      // If still no image, try using Shopify's image_url filter approach
      if (!imageUrl && product.featured_image) {
        // Sometimes the URL needs to be constructed differently
        imageUrl = product.featured_image.replace(/\?.*$/, '') + '?width=400';
      }
      const aspectRatio = product.featured_media ?
        product.featured_media.aspect_ratio || product.featured_media.preview_image.aspect_ratio || 1 :
        1;
      // Only create and append if product is available
      if (product.available === true) {
        productItem.innerHTML = `
          <div class="ProductItem__Wrapper">
            <div class="ProductItem__ImageWrapper overflow-hidden">
              ${imageUrl ? `
                <div class="AspectRatio AspectRatio--square" style="--aspect-ratio: ${aspectRatio}">
                  <img 
                    class="ProductItem__Image Image--lazyLoad Image--fadeIn" 
                    src="${imageUrl}" 
                    alt="${product.title}" 
                    loading="lazy"
                    style="object-fit: cover; width: 100%; height: 100%;"
                  >
                </div>
              ` : `
                <div class="AspectRatio AspectRatio--square">
                  <div style="display: flex; align-items: center; justify-content: center; height: 100%; background: #f5f5f5; color: #999;">
                    No Image
                  </div>
                </div>
              `}
            </div>
            <div class="ProductItem__Info ProductItem__Info--center p-3">
              <h2 class="ProductItem__Title Heading text-sm mb-2">${product.title}</h2>
              <div class="ProductItem__PriceList Heading text-sm">
                <span class="ProductItem__Price Price">${formatPrice(product.price)}</span>
              </div>
            </div>
          </div>
        `;
        modalGrid.appendChild(productItem);
      } else {
        // console.log(`Skipped unavailable product: ${product.title}`);
      }
    });
    // Show modal using theme's existing PageOverlay system  
    modal.style.display = 'flex';
    const pageOverlay = document.querySelector('.CustomPageOverlay');
    if (pageOverlay) {
      pageOverlay.classList.add('is-visible');
      // Add click handler to close modal when clicking overlay
      const overlayClickHandler = (e) => {
        if (e.target === pageOverlay) {
          closeProductModal();
          pageOverlay.removeEventListener('click', overlayClickHandler);
        }
      };
      pageOverlay.addEventListener('click', overlayClickHandler);
    }
    document.body.style.overflow = 'hidden';
  }
  function closeProductModal() {
    const modal = document.getElementById('productSelectionModal');
    const pageOverlay = document.querySelector('.CustomPageOverlay');
    if (pageOverlay) {
      pageOverlay.classList.remove('is-visible');
    }
    modal.style.display = 'none';
    modal.innerHTML = ''; // Clear modal content
    document.body.style.overflow = '';
  }
  function formatPrice(priceInCents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(priceInCents / 100);
  }
  // Trust Badges Carousel functionality
  function initTrustBadgesCarousel() {
    const trustBadgesCarousel = document.querySelector('[data-carousel-track]');
    const indicators = document.querySelectorAll('[data-carousel-indicator]');
    if (trustBadgesCarousel && indicators.length > 0) {
      let currentSlide = 0;
      const totalSlides = indicators.length;
      const slideInterval = 3000; // 3 seconds
      function goToSlide(slideIndex) {
        currentSlide = slideIndex;
        const translateX = -100 * slideIndex;
        trustBadgesCarousel.style.transform = `translateX(${translateX}%)`;
        // Update indicators/dots
        indicators.forEach((indicator, index) => {
          const span = indicator.querySelector('span');
          if (index === slideIndex) {
            indicator.classList.add('nx-active');
            if (span) {
              span.classList.remove('opacity-25');
              span.classList.add('opacity-75');
            }
          } else {
            indicator.classList.remove('nx-active');
            if (span) {
              span.classList.remove('opacity-75');
              span.classList.add('opacity-25');
            }
          }
        });
      }
      function nextSlide() {
        const nextIndex = (currentSlide + 1) % totalSlides;
        goToSlide(nextIndex);
      }
      // Add click listeners to indicators
      indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => {
          goToSlide(index);
        });
      });
      // Auto-rotate slides
      if (totalSlides > 1) {
        setInterval(nextSlide, slideInterval);
      }
    }
  }
  // Initialize trust badges carousel
  initTrustBadgesCarousel();
  // Product Accordion functionality with chevron icons
  function initProductAccordion() {
    const accordionButtons = document.querySelectorAll('[data-accordion-toggle]');
    // Ensure first accordion content has proper height on page load
    accordionButtons.forEach(button => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        const targetId = button.getAttribute('data-accordion-toggle');
        const content = document.getElementById(targetId);
        if (content) {
          // Ensure proper height is set for initially open accordion
          content.style.height = 'auto';
          content.style.visibility = 'visible';
        }
      }
    });
    accordionButtons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-accordion-toggle');
        const content = document.getElementById(targetId);
        const chevron = this.querySelector('.nx-accordion-chevron');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        // Close all other accordions in the same container
        const container = this.closest('.nx-accordions');
        if (container) {
          const allButtons = container.querySelectorAll('[data-accordion-toggle]');
          const allContents = container.querySelectorAll('.nx-accordion-content');
          const allChevrons = container.querySelectorAll('.nx-accordion-chevron');
          allButtons.forEach(btn => {
            btn.setAttribute('aria-expanded', 'false');
          });
          allContents.forEach(contentEl => {
            contentEl.style.height = '0';
            contentEl.style.visibility = 'hidden';
            contentEl.style.transition = 'height 0.35s ease-in-out';
          });
          allChevrons.forEach(chev => {
            chev.style.transform = 'rotate(0deg)';
          });
        }
        // Toggle current accordion
        if (!isExpanded) {
          // Open accordion
          this.setAttribute('aria-expanded', 'true');
          content.style.visibility = 'visible';
          content.style.height = 'auto';
          const height = content.scrollHeight;
          content.style.height = '0';
          // Trigger animation
          setTimeout(() => {
            content.style.transition = 'height 0.35s ease-in-out';
            content.style.height = height + 'px';
          }, 10);
          if (chevron) {
            chevron.style.transform = 'rotate(-180deg)';
          }
        } else {
          // Close accordion
          this.setAttribute('aria-expanded', 'false');
          content.style.transition = 'height 0.35s ease-in-out';
          content.style.height = '0';
          setTimeout(() => {
            content.style.visibility = 'hidden';
          }, 350);
          if (chevron) {
            chevron.style.transform = 'rotate(0deg)';
          }
        }
      });
    });
  }
  // Initialize product accordion
  initProductAccordion();
  // Get all bundle products (selected + included free)
  function getAllBundleProducts(sourceElement = null, productContext = document) {
    const bundleProducts = [];
    const addedVariantIds = new Set(); // Track added variants to prevent duplicates
    // Get the main product info
    let productForm = null;
    if (sourceElement) {
      if (sourceElement.matches && sourceElement.matches('form[action*="/cart/add"]')) {
        productForm = sourceElement;
      } else if (sourceElement.form && sourceElement.form.matches && sourceElement.form.matches('form[action*="/cart/add"]')) {
        productForm = sourceElement.form;
      } else {
        const formId = sourceElement.getAttribute && sourceElement.getAttribute('form');
        if (formId) {
          const linkedForm = document.getElementById(formId);
          if (linkedForm && linkedForm.matches && linkedForm.matches('form[action*="/cart/add"]')) {
            productForm = linkedForm;
          }
        }
      }
    }
    if (!productForm) {
      productForm = document.querySelector('form[action*="/cart/add"]');
    }
    let mainProductId = null;
    let parsedMainQuantity = NaN;
    if (productForm) {
      const submittedData = new FormData(productForm);
      mainProductId = submittedData.get('id') || productForm.querySelector('[name="id"]')?.value || null;
      const quantityCandidates = [];
      if (productForm.id) {
        quantityCandidates.push(...document.querySelectorAll(`[name="quantity"][form="${productForm.id}"]`));
      }
      quantityCandidates.push(...productForm.querySelectorAll('[name="quantity"]'));
      for (const input of quantityCandidates) {
        const value = parseInt(input?.value, 10);
        if (!Number.isFinite(value) || value <= 0) {
          continue;
        }
        const isVisible = !!(input.offsetWidth || input.offsetHeight || input.getClientRects().length);
        if (isVisible) {
          parsedMainQuantity = value;
          break;
        }
        if (!Number.isFinite(parsedMainQuantity)) {
          parsedMainQuantity = value;
        }
      }
      if (!Number.isFinite(parsedMainQuantity)) {
        parsedMainQuantity = parseInt(submittedData.get('quantity'), 10);
      }
    }
    const mainProductQuantity = Number.isFinite(parsedMainQuantity) && parsedMainQuantity > 0 ? parsedMainQuantity : 1;
    if (mainProductId) {
      bundleProducts.push({
        id: mainProductId,
        quantity: mainProductQuantity,
        type: 'main_product'
      });
      addedVariantIds.add(mainProductId); // Track main product variant
      // console.log(`Added main product variant: ${mainProductId}`);
    }
    // Get all bundle selector buttons and included items
    const allButtons = productContext.querySelectorAll('.nx-free-product-selector__button');
    const allIncludedItems = productContext.querySelectorAll('.nx-free-product-selector__included');
    // console.log(`Found ${allButtons.length} bundle selector buttons and ${allIncludedItems.length} included items`);
    // Process regular buttons
    allButtons.forEach((button, index) => {
      // console.log(`Processing button ${index + 1}:`, {
      //   slot: button.dataset.slot,
      //   slotType: button.dataset.slotType,
      //   productId: button.dataset.productId,
      //   variantId: button.dataset.variantId,
      //   selectedProductId: button.dataset.selectedProductId,
      //   isSelected: button.classList.contains('selected'),
      //   isSelected: button.classList.contains('selected')
      // });
      const slot = button.dataset.slot;
      const slotType = button.dataset.slotType;
      let productId = null;
      let variantId = null;
      if (slotType === 'single_product' && button.classList.contains('selected')) {
        productId = button.dataset.selectedProductId || button.dataset.productId;
        // For single products, we need to get the first available variant
        variantId = getFirstVariantId(productId, button);
      } else if ((slotType === 'product_list' || slotType === 'collection') && button.classList.contains('selected')) {
        productId = button.dataset.selectedProductId;
        // For selected products from list or collection, get the first variant
        variantId = getSelectedProductVariantId(button);
      }
      // Add product if we have a variant ID and it's selected
      if (variantId && button.classList.contains('selected')) {
        // Check if this variant has already been added
        if (addedVariantIds.has(variantId)) {
          // console.log(`Skipped duplicate variant: ${variantId} for product ${productId}`);
        } else {
          bundleProducts.push({
            id: variantId, // Use variant ID instead of product ID
            quantity: 1,
            type: 'customer_selected',
            slot: slot,
            productId: productId // Keep product ID for reference
          });
          addedVariantIds.add(variantId); // Track this variant
          // console.log(`✅ Added to bundle: Product ${productId} -> Variant ${variantId} (selected)`);
        }
      } else {
        // Log detailed reasons why products are being skipped
        // const reasons = [];
        // if (!variantId) reasons.push('no variant ID');
        // if (!button.classList.contains('selected')) reasons.push('not selected');
        // console.log(`⚠️ Skipped: Product ${productId}, Variant ${variantId}, Reasons: ${reasons.join(', ')}`);
      }
    });
    // Process new bundle selector (only explicitly selected items for normal ATC flow)
    const allBundleOpenButtons = productContext.querySelectorAll('.nx-bundle-selector [data-bundle-open]');
    allBundleOpenButtons.forEach((button, buttonIndex) => {
      let variantId = button.dataset.selectedVariantId;
      let productId = button.dataset.selectedProductId || null;
      /* Position, not label. The button's order in the selector is stable;
         its wording is not. */
      const stableSlot = window.ASL_SLOT_KEYS[buttonIndex] || ('slot_' + (buttonIndex + 1));
      if (variantId && !addedVariantIds.has(variantId)) {
        bundleProducts.push({
          id: variantId,
          quantity: 1,
          type: 'bundle_selector_selected',
          slot: stableSlot,
          productId: productId
        });
        addedVariantIds.add(variantId);
      }
    });
    const fixedBundleButtons = productContext.querySelectorAll('.nx-bundle-selector [data-bundle-fixed-variant-id]');
    fixedBundleButtons.forEach((button) => {
      const variantId = button.dataset.bundleFixedVariantId;
      const productId = button.dataset.bundleFixedProductId || null;
      const fixedSlot = button.dataset.bundleFixedSlot || 'bundle_selector_fixed';
      if (variantId && !addedVariantIds.has(variantId)) {
        bundleProducts.push({
          id: variantId,
          quantity: 1,
          type: 'bundle_selector_fixed',
          slot: fixedSlot,
          productId: productId
        });
        addedVariantIds.add(variantId);
      }
    });
    return bundleProducts;
  }
  // Add bundle to cart using Shopify Cart API
  function addBundleToCart(bundleProducts) {
    // console.log('🛒 Adding bundle to cart:', bundleProducts);
    // Validate bundle products before proceeding
    if (!bundleProducts || bundleProducts.length === 0) {
      console.error('❌ No bundle products to add to cart');
      return;
    }
    // Validate each product has required fields
    const validProducts = bundleProducts.filter(product => {
      const isValid = product.id && product.quantity && product.quantity > 0;
      if (!isValid) {
        console.error('❌ Invalid product detected:', product);
      }
      return isValid;
    });
    if (validProducts.length === 0) {
      console.error('❌ No valid products found in bundle');
      return;
    }
    if (validProducts.length !== bundleProducts.length) {
      // console.warn('⚠️ Some invalid products were filtered out:', {
      //   original: bundleProducts.length,
      //   valid: validProducts.length
      // });
    }
    // Generate a unique bundle ID so we can link main + gifts
    const bundleId = 'bundle_' + Date.now();
    // Prepare items for Shopify Cart API
    const items = validProducts.map(product => ({
      id: product.id,
      quantity: product.quantity,
      properties: {
        '_bundle_type': product.type,
        '_bundle_slot': window.aslSlotKey(product.slot || 'main'),
        '_bundle_id': bundleId
      }
    }));
    // console.log('🛒 Prepared cart items:', items);
    // Use Shopify's Cart API to add multiple items
    fetch(window.aslCartUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(response => {
        // console.log('🛒 Cart API Response status:', response.status);
        if (!response.ok) {
          return response.text().then(text => {
            throw new Error(`HTTP ${response.status}: ${text}`);
          });
        }
        return response.json();
      })
      .then(data => {
        // console.log('✅ Bundle added to cart successfully:', data);
        // Validate the response data
        if (!data || (data.items && data.items.length === 0)) {
          // console.warn('⚠️ Cart API returned success but no items were added');
        }
        // Trigger cart refresh events that your theme might use
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        // Open cart drawer explicitly after refresh (reliable for this theme setup).
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
          } else {
            // Fallback drawer-open events
            document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('drawer:open', {
              bubbles: true,
              detail: { drawer: 'cart' }
            }));
          }
        }, 120);
        // Trigger product added event for theme integration
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: data.items?.[0] || {},
            quantity: validProducts.reduce((sum, p) => sum + p.quantity, 0)
          }
        }));
        // Clear all selections after successful cart addition
        clearAllSelections();
        // Show success message or redirect
        if (window.location.pathname.includes('/cart')) {
          // If on cart page, reload to show updated cart
          window.location.reload();
        } else {
          // Otherwise, could show a notification or redirect to cart
          // console.log('✅ Bundle added successfully! Items:', data.items?.length || validProducts.length);
        }
      })
      .catch(error => {
        console.error('❌ Error adding bundle to cart:', error);
        // Fallback: try adding items one by one
        // console.log('🔄 Attempting fallback: sequential item addition');
        addBundleItemsSequentially(validProducts);
      });
  }
  // Fallback method: add items one by one
  // Helper function to get first variant ID for a product
  function getFirstVariantId(productId, button) {
    // Method 1: Check if variant ID is stored as data attribute (from selected_or_first_available_variant)
    const variantId = button.dataset.variantId;
    if (variantId && variantId !== 'undefined' && variantId !== '') {
      // console.log(`Using data-variant-id: ${variantId} for product ${productId}`);
      return variantId;
    }
    // Method 2: If we have product list data, get first variant
    try {
      const productListData = button.dataset.productList;
      if (productListData) {
        const products = JSON.parse(productListData);
        const product = products.find(p => p.id.toString() === productId.toString());
        if (product && product.variants && product.variants.length > 0) {
          return product.variants[0].id;
        }
      }
    } catch (error) {
      console.error('Error parsing product list for variant:', error);
    }
    // Method 3: Fallback - try to find variant from global product data if available
    if (window.productVariants && window.productVariants[productId]) {
      return window.productVariants[productId][0];
    }
    console.warn(`Could not find variant ID for product ${productId}`);
    return null;
  }
  // Helper function to get variant ID for selected product from modal
  function getSelectedProductVariantId(button) {
    const productId = button.dataset.selectedProductId;
    try {
      const productListData = button.dataset.productList;
      if (productListData) {
        const products = JSON.parse(productListData);
        const selectedProduct = products.find(p => p.id.toString() === productId.toString());
        if (selectedProduct && selectedProduct.available && selectedProduct.variants && selectedProduct.variants.length > 0) {
          // Get the first available variant
          const availableVariant = selectedProduct.variants.find(v => v.available);
          if (availableVariant) {
            return availableVariant.id;
          } else {
            console.warn(`No available variants for product ${productId}`);
            return null;
          }
        }
      }
    } catch (error) {
      console.error('Error getting selected product variant:', error);
    }
    console.warn(`Could not find variant ID for selected product ${productId}`);
    return null;
  }
  function addBundleItemsSequentially(bundleProducts) {
    // console.log('🔄 Trying sequential add as fallback for', bundleProducts.length, 'items');
    let addedCount = 0;
    let failedCount = 0;
    async function addNextItem(index, retryCount = 0) {
      if (index >= bundleProducts.length) {
        // console.log(`✅ Sequential add complete: ${addedCount} added, ${failedCount} failed`);
        // Trigger cart refresh
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        // If some items failed, show a warning
        if (failedCount > 0) {
          console.warn(`⚠️ Warning: ${failedCount} items failed to add to cart`);
        }
        return;
      }
      const product = bundleProducts[index];
      const maxRetries = 2;
      try {
        // console.log(`🛒 Adding item ${index + 1}/${bundleProducts.length} (attempt ${retryCount + 1}):`, product);
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
        const response = await fetch(window.aslCartUrl('cart/add.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: product.id,
            quantity: product.quantity,
            properties: {
              '_bundle_type': product.type,
              '_bundle_slot': window.aslSlotKey(product.slot || 'main')
            }
          }),
          signal: controller.signal
        });
        clearTimeout(timeoutId);
        if (response.ok) {
          addedCount++;
          // console.log(`✅ Added item ${index + 1}/${bundleProducts.length} to cart`);
          // Add next item after a short delay
          setTimeout(() => addNextItem(index + 1), 300);
        } else {
          const errorText = await response.text();
          console.error(`❌ Failed to add item ${index + 1} (HTTP ${response.status}):`, errorText);
          // Retry if we haven't exceeded max retries
          if (retryCount < maxRetries) {
            // console.log(`🔄 Retrying item ${index + 1} (attempt ${retryCount + 2})`);
            setTimeout(() => addNextItem(index, retryCount + 1), 1000);
          } else {
            failedCount++;
            console.error(`❌ Item ${index + 1} failed after ${maxRetries + 1} attempts`);
            // Continue with next item
            setTimeout(() => addNextItem(index + 1), 300);
          }
        }
      } catch (error) {
        clearTimeout(timeoutId);
        console.error(`❌ Error adding item ${index + 1}:`, error);
        // Retry if we haven't exceeded max retries and it's not an abort error
        if (retryCount < maxRetries && error.name !== 'AbortError') {
          // console.log(`🔄 Retrying item ${index + 1} after error (attempt ${retryCount + 2})`);
          setTimeout(() => addNextItem(index, retryCount + 1), 1000);
        } else {
          failedCount++;
          console.error(`❌ Item ${index + 1} failed after ${maxRetries + 1} attempts`);
          // Continue with next item
          setTimeout(() => addNextItem(index + 1), 300);
        }
      }
    }
    addNextItem(0);
  }
  // Free Product Selector Interactions
  function initFreeProductSelector() {
    // Handle product selection buttons
    document.addEventListener('click', async (e) => {
      // Handle opening product modal for product lists
      if (e.target.closest('[data-action="open-product-modal"]')) {
        const button = e.target.closest('[data-action="open-product-modal"]');
        const slot = button.dataset.slot;
        const productListData = button.dataset.productList;
        try {
          const productList = JSON.parse(productListData);
          openProductModal(slot, productList, button);
        } catch (error) {
          console.error('Error parsing product list data:', error);
        }
        return;
      }
      // Handle Clear All button
      if (e.target.closest('[data-action="clear-all-selections"]')) {
        clearAllSelections();
        return;
      }
      // Handle single product selection (now works like product modal)
      if (e.target.closest('.nx-free-product-selector__button[data-slot-type="single_product"]')) {
        const button = e.target.closest('.nx-free-product-selector__button');
        const slot = button.dataset.slot;
        const productId = button.dataset.productId;
        // For single_product, we can directly set it as selected since there's only one option
        // Remove selected state from other buttons in the same slot only
        const container = button.closest('.nx-free-product-selector');
        container.querySelectorAll(`.nx-free-product-selector__button[data-slot="${slot}"]`).forEach(btn => {
          btn.classList.remove('selected');
        });
        // Add selected state to clicked button
        button.classList.add('selected');
        button.dataset.selectedProductId = productId;
        // console.log(`Free Product Selector: Selected single product ${productId} for slot ${slot}`);
        // Update Clear All button visibility
        updateClearAllButton();
      }
      // Handle modal close
      if (e.target.closest('[data-action="close-modal"]')) {
        closeProductModal();
        return;
      }
      // Handle product selection in modal
      if (e.target.closest('.nx-product-modal__item')) {
        const item = e.target.closest('.nx-product-modal__item');
        const productId = item.dataset.productId;
        const productTitle = item.dataset.productTitle;
        const slot = item.dataset.slot;
        // Remove previous selections in modal
        document.querySelectorAll('.nx-product-modal__item').forEach(modalItem => {
          modalItem.classList.remove('selected');
        });
        // Select clicked item
        item.classList.add('selected');
        // Update the original button with selected product info
        const originalButton = document.querySelector(`[data-slot="${slot}"][data-action="open-product-modal"]`);
        if (originalButton) {
          originalButton.classList.add('selected');
          originalButton.dataset.selectedProductId = productId;
          // Get the selected product data to update the button
          const selectedProduct = JSON.parse(originalButton.dataset.productList).find(p => p.id.toString() === productId);
          if (selectedProduct) {
            // console.log('Selected product for image update:', selectedProduct);
            // Update the image
            const imageContainer = originalButton.querySelector('.nx-free-product-selector__image');
            // console.log('Image container found:', !!imageContainer);
            if (imageContainer) {
              const img = imageContainer.querySelector('img');
              // console.log('Image element found:', !!img);
              if (img) {
                // Try multiple approaches to get the image URL
                let newImageUrl = '';
                if (selectedProduct.featured_media && selectedProduct.featured_media.preview_image && selectedProduct.featured_media.preview_image.src) {
                  newImageUrl = selectedProduct.featured_media.preview_image.src;
                  newImageUrl = newImageUrl.replace(/\.(jpg|jpeg|png|gif|webp|JPG|JPEG|PNG|GIF|WEBP)$/, '_240x240.$1');
                } else if (selectedProduct.featured_image) {
                  newImageUrl = selectedProduct.featured_image.replace(/\?.*$/, '') + '?width=240';
                } else if (selectedProduct.images && selectedProduct.images.length > 0) {
                  newImageUrl = selectedProduct.images[0].replace(/\?.*$/, '') + '?width=240';
                }
                // console.log('New image URL:', newImageUrl);
                if (newImageUrl) {
                  img.src = newImageUrl;
                  img.alt = selectedProduct.title;
                  // Show the image container if it was hidden
                  imageContainer.classList.remove('hidden');
                  imageContainer.classList.add('block');
                  // console.log('Image updated successfully');
                } else {
                  // console.log('No valid image URL found for product');
                }
              }
            } else {
              // If no image container exists, create one
              // console.log('No image container found, creating one');
              const newImageContainer = document.createElement('div');
              newImageContainer.className = 'nx-free-product-selector__image';
              let newImageUrl = '';
              if (selectedProduct.featured_media && selectedProduct.featured_media.preview_image && selectedProduct.featured_media.preview_image.src) {
                newImageUrl = selectedProduct.featured_media.preview_image.src;
                newImageUrl = newImageUrl.replace(/\.(jpg|jpeg|png|gif|webp|JPG|JPEG|PNG|GIF|WEBP)$/, '_240x240.$1');
              } else if (selectedProduct.featured_image) {
                newImageUrl = selectedProduct.featured_image.replace(/\?.*$/, '') + '?width=240';
              }
              if (newImageUrl) {
                newImageContainer.innerHTML = `
                  <img 
                    src="${newImageUrl}" 
                    alt="${selectedProduct.title}"
                    width="240"
                    height="240"
                  >
                `;
                // Insert the image container before the title span
                const titleSpan = originalButton.querySelector('span.font-medium');
                if (titleSpan) {
                  originalButton.insertBefore(newImageContainer, titleSpan);
                }
              }
            }
            // Update the title (truncated to 30 characters)
            const titleSpan = originalButton.querySelector('span.font-medium');
            if (titleSpan) {
              const truncatedTitle = selectedProduct.title.length > 30
                ? selectedProduct.title.substring(0, 30) + '...'
                : selectedProduct.title;
              titleSpan.textContent = truncatedTitle;
            }
            // Hide the selected product name span since we're now showing the actual product
            const selectedProductSpan = originalButton.querySelector('[data-selected-product-name]');
            if (selectedProductSpan) {
              selectedProductSpan.style.display = 'none';
            }
          }
        }
        // console.log(`Free Product Selector: Selected product ${productId} (${productTitle}) for slot ${slot}`);
        // Update Clear All button visibility
        updateClearAllButton();
        // Close modal after selection
        setTimeout(() => closeProductModal(), 300);
        return;
      }
      // Handle main add to cart button with free products
      if (e.target.closest('[data-action="add-to-cart"]')) {
        const atcButton = e.target.closest('[data-action="add-to-cart"]');
        const productContext = atcButton.closest('.product-info');
        if (!productContext) {
          // No product-info container, allow normal form submission
          return;
        }
        const hasFreeProductSelector = productContext.querySelector('.nx-free-product-selector');
        const hasBundleSelector = productContext.querySelector('.nx-bundle-selector');
        if (!hasFreeProductSelector && !hasBundleSelector) {
          // No free product selector on this specific product, let form submit normally
          return;
        }
        const allBundleProducts = getAllBundleProducts(atcButton, productContext);
        console.log('Free Product Selector: Bundle products to add:', allBundleProducts);
        // Count selected/included products (excluding main product)
        const bundleItems = allBundleProducts.filter(item => item.type !== 'main_product');
        const selectedButtons = document.querySelectorAll('.nx-free-product-selector__button.selected');
        const includedItems = document.querySelectorAll('.nx-free-product-selector__included');
        const selectedBundleItems = document.querySelectorAll('.nx-bundle-selector [data-bundle-open][data-selected-variant-id]');
        const fixedBundleItems = document.querySelectorAll('.nx-bundle-selector [data-bundle-fixed-variant-id]');
        const shouldInterceptForBundleSelector = hasBundleSelector === true;
        console.log('Free Product Selector: Bundle validation:', {
          totalBundleProducts: allBundleProducts.length,
          bundleItemsCount: bundleItems.length,
          selectedButtonsCount: selectedButtons.length,
          includedItemsCount: includedItems.length,
          selectedBundleItemsCount: selectedBundleItems.length,
          fixedBundleItemsCount: fixedBundleItems.length,
          shouldIntercept: shouldInterceptForBundleSelector ? true : (bundleItems.length > 0 || selectedButtons.length > 0 || includedItems.length > 0)
        });
        // Intercept if we have ANY bundle products (selected OR included) OR if we detect selection UI
        if (shouldInterceptForBundleSelector || bundleItems.length > 0 || selectedButtons.length > 0 || includedItems.length > 0) {
          e.preventDefault(); // Prevent default form submission
          e.stopImmediatePropagation();
          // Double-check we have valid bundle products
          if (allBundleProducts.length > 0) {
            console.log('✅ Free Product Selector: Intercepting cart submission - found bundle products');
            addBundleToCart(allBundleProducts);
          } else {
            console.error('❌ Bundle products detected but getAllBundleProducts returned empty - using fallback');
            // For fallback, just submit the form normally to avoid complexity
            // The main product will be added by the theme, and selected items might be missed
            // But this prevents duplicate main products
            console.log('⚠️ Free Product Selector: Using fallback - submitting form normally');
            e.target.closest('form').submit();
          }
        } else {
          // No bundle products selected, let the form submit normally
          console.log('Free Product Selector: No bundle products detected, allowing normal form submission');
          // Don't prevent default - let the theme handle it normally
        }
      }
      // Handle auto-select functionality (if you want to keep this option)
      if (e.target.dataset.action === 'auto-select') {
        // console.log('Free Product Selector: Auto-select clicked');
        // Auto-select first available products
        const container = e.target.closest('.nx-free-product-selector');
        const buttons = container.querySelectorAll('.nx-free-product-selector__button');
        buttons.forEach((button, index) => {
          setTimeout(() => {
            button.click();
          }, index * 200);
        });
      }
      // Handle "CHOOSE FREE GIFTS FOR ME" button click
      if (e.target.closest('[data-action="bundle-auto-select-add"]')) {
        const autoAddBtn = e.target.closest('[data-action="bundle-auto-select-add"]');
        e.preventDefault();
        e.stopPropagation();
        const formId = autoAddBtn.getAttribute('form');
        const form = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        const mainVariantId = form.querySelector('[name="id"]')?.value;
        if (!mainVariantId) return;
        const giftVariantIdsBySlot = [
          String(autoAddBtn.dataset.gift1 || '').trim(),
          String(autoAddBtn.dataset.gift2 || '').trim(),
          String(autoAddBtn.dataset.gift3 || '').trim(),
          String(autoAddBtn.dataset.gift4 || '').trim(),
          String(autoAddBtn.dataset.gift5 || '').trim(),
          String(autoAddBtn.dataset.gift6 || '').trim()
        ];
        // Hard fallback for fixed gifts (slots 4-6):
        // read directly from bundle selector fixed buttons if dataset gifts are blank.
        const productContext = autoAddBtn.closest('.product-info');
        if (productContext) {
          const fixedButtons = Array.from(productContext.querySelectorAll('.nx-bundle-selector [data-bundle-fixed-variant-id]'));
          const fixedIds = fixedButtons
            .map((btn) => String(btn.dataset.bundleFixedVariantId || '').trim())
            .filter(Boolean);
          for (let i = 0; i < fixedIds.length && i < 3; i++) {
            const slotIndex = 3 + i; // maps to gift 4,5,6
            if (!giftVariantIdsBySlot[slotIndex]) {
              giftVariantIdsBySlot[slotIndex] = fixedIds[i];
            }
          }
        }
        const parseCandidates = (raw) => {
          return (raw || '')
            .split(',')
            .map((chunk) => chunk.trim())
            .filter(Boolean)
            .map((chunk) => {
              const [id, qty, policy] = chunk.split(':');
              return {
                id: String(id || '').trim(),
                qty: Number.isFinite(parseInt(qty, 10)) ? parseInt(qty, 10) : 0,
                policy: String(policy || '').trim()
              };
            })
            .filter((c) => c.id);
        };
        const isCandidateSellable = (candidate, cartQtyByVariant) => {
          if (!candidate || !candidate.id) return false;
          const inCart = cartQtyByVariant.get(candidate.id) || 0;
          return candidate.policy === 'continue' || candidate.qty <= 0 || inCart < candidate.qty;
        };
        const pickAvailableCandidate = (candidates, cartQtyByVariant) => {
          for (const candidate of candidates) {
            if (isCandidateSellable(candidate, cartQtyByVariant)) {
              return candidate.id;
            }
          }
          return '';
        };
        try {
          const cartRes = await fetch(window.aslCartUrl('cart.js'), { headers: { 'Accept': 'application/json' } });
          if (cartRes.ok) {
            const cart = await cartRes.json();
            const cartQtyByVariant = new Map();
            (cart.items || []).forEach((item) => {
              const key = String(item.variant_id);
              cartQtyByVariant.set(key, (cartQtyByVariant.get(key) || 0) + (item.quantity || 0));
            });
            // Prefer the product metafield variant when it still passes the same inventory
            // rule as the legacy candidate list; otherwise fall back to the legacy picker.
            const slot1Candidates = parseCandidates(autoAddBtn.dataset.slot1Candidates);
            const slot1MetafieldVariant = String(autoAddBtn.dataset.slot1MetafieldVariant || '').trim();
            const slot1MetafieldCandidate = slot1Candidates.find((candidate) => candidate.id === slot1MetafieldVariant);
            const slot1 = isCandidateSellable(slot1MetafieldCandidate, cartQtyByVariant)
              ? slot1MetafieldVariant
              : pickAvailableCandidate(slot1Candidates, cartQtyByVariant);
            if (slot1) giftVariantIdsBySlot[0] = slot1;
            const slot2Candidates = parseCandidates(autoAddBtn.dataset.slot2Candidates);
            const slot2MetafieldVariant = String(autoAddBtn.dataset.slot2MetafieldVariant || '').trim();
            const slot2MetafieldCandidate = slot2Candidates.find((candidate) => candidate.id === slot2MetafieldVariant);
            const slot2 = isCandidateSellable(slot2MetafieldCandidate, cartQtyByVariant)
              ? slot2MetafieldVariant
              : pickAvailableCandidate(slot2Candidates, cartQtyByVariant);
            if (slot2) giftVariantIdsBySlot[1] = slot2;
            const slot3Candidates = parseCandidates(autoAddBtn.dataset.slot3Candidates);
            const slot3MetafieldVariant = String(autoAddBtn.dataset.slot3MetafieldVariant || '').trim();
            const slot3MetafieldCandidate = slot3Candidates.find((candidate) => candidate.id === slot3MetafieldVariant);
            const slot3 = isCandidateSellable(slot3MetafieldCandidate, cartQtyByVariant)
              ? slot3MetafieldVariant
              : pickAvailableCandidate(slot3Candidates, cartQtyByVariant);
            if (slot3) giftVariantIdsBySlot[2] = slot3;
          }
        } catch (err) {
          console.warn('Auto gift availability check failed; using default variants', err);
        }
        // Build the items array: main product + gift products (1 qty each)
        const bundleProducts = [
          { id: mainVariantId, quantity: 1, type: 'main_product', slot: 'main' }
        ];
        giftVariantIdsBySlot.forEach((id, idx) => {
          if (!id) return;
          bundleProducts.push({
            id: id.trim(),
            quantity: 1,
            type: 'auto_gift',
            slot: 'auto_gift_' + (idx + 1)
          });
        });
        // Use the existing addBundleToCart function
        addBundleToCart(bundleProducts);
        return;
      }
    });
    // Fallback submit interception to ensure bundle items are added even when click delegation misses
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) {
        return;
      }
      const productContext = form.closest('.product-info');
      if (!productContext) {
        return;
      }
      const hasFreeProductSelector = productContext.querySelector('.nx-free-product-selector');
      const hasBundleSelector = productContext.querySelector('.nx-bundle-selector');
      if (!hasFreeProductSelector && !hasBundleSelector) {
        return;
      }
      const allBundleProducts = getAllBundleProducts(form, productContext);
      const bundleItems = allBundleProducts.filter(item => item.type !== 'main_product');
      if (!bundleItems.length && !hasBundleSelector) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundleToCart(allBundleProducts);
    }, true);
  }
  // Cart drawer functionality for header cart link
  function initCartDrawer() {
    // Find cart links in header and intercept clicks
    const cartLinks = document.querySelectorAll(`a[href="${window.aslCartUrl('cart')}"]`);
    cartLinks.forEach(cartLink => {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent navigation to /cart page
        // Trigger cart drawer open event
        document.documentElement.dispatchEvent(new CustomEvent('cart:open', {
          bubbles: true
        }));
        // Try multiple approaches to open cart drawer
        let drawerOpened = false;
        // // Method 1: Look for common cart drawer trigger selectors
        // const possibleTriggers = [
        //   '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]',
        //   '[data-action="open-drawer"][data-drawer-id="cart"]',
        //   '[data-action="toggle-drawer"][data-drawer-id="sidebar-cart"]',
        //   '[data-action="toggle-drawer"][data-drawer-id="cart"]',
        //   '.js-drawer-open-cart',
        //   '.cart-drawer-toggle',
        //   '[data-cart-drawer-toggle]'
        // ];
        // for (const selector of possibleTriggers) {
        //   const trigger = document.querySelector(selector);
        //   if (trigger) {
        //     trigger.click();
        //     drawerOpened = true;
        //     // console.log(`Cart drawer opened using trigger: ${selector}`);
        //     break;
        //   }
        // }
        // Method 2: If no trigger found, try theme-specific events
        if (!drawerOpened) {
          // Check if theme has a global cart drawer function
          if (window.theme && typeof window.theme.openCartDrawer === 'function') {
            window.theme.openCartDrawer();
            drawerOpened = true;
            // console.log('Cart drawer opened using theme.openCartDrawer()');
          } else if (window.Drawer && typeof window.Drawer.open === 'function') {
            window.Drawer.open('sidebar-cart');
            drawerOpened = true;
            // console.log('Cart drawer opened using Drawer.open()');
          }
        }
        // Method 3: Dispatch multiple cart events as fallback
        if (!drawerOpened) {
          const cartEvents = [
            'cart:open',
            'cart:toggle',
            'drawer:open',
            'sidebar:open',
            'cart:refresh'
          ];
          cartEvents.forEach(eventName => {
            document.documentElement.dispatchEvent(new CustomEvent(eventName, {
              bubbles: true,
              detail: { drawer: 'cart', source: 'header-cart-link' }
            }));
          });
          // console.log('Cart drawer events dispatched as fallback');
        }
        // console.log('Cart drawer open attempted');
      });
    });
    // console.log(`Cart drawer initialized for ${cartLinks.length} cart links`);
  }
  // Initialize free product selector features
  initFreeProductCountdown();
  initFreeProductSelector();
  // Store original slot titles for proper reset
  storeOriginalTitles();
  // Initialize Clear All button visibility
  updateClearAllButton();
  // Initialize cart drawer functionality for header cart link
  initCartDrawer();
  // Keep DOM line-item keys synchronized when third-party apps mutate cart lines/keys.
  async function syncCartDomLineKeys() {
    try {
      const response = await fetch(window.aslCartUrl('cart.js'), { headers: { 'Accept': 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const items = Array.isArray(cart?.items) ? cart.items : [];
      if (!items.length) return;
      const grouped = new Map();
      items.forEach((item) => {
        const variantId = String(item.variant_id || '');
        const bundleId = String(item?.properties?._bundle_id || '');
        const bundleSlot = String(item?.properties?._bundle_slot || '');
        const signature = `${variantId}::${bundleId}::${bundleSlot}`;
        if (!grouped.has(signature)) grouped.set(signature, []);
        grouped.get(signature).push(item.key);
      });
      const counters = new Map();
      const lineItems = document.querySelectorAll('line-item');
      lineItems.forEach((lineItemEl) => {
        const identityNode = lineItemEl.querySelector('[data-line-variant-id]');
        if (!identityNode) return;
        const variantId = String(identityNode.getAttribute('data-line-variant-id') || '');
        if (!variantId) return;
        const bundleId = String(identityNode.getAttribute('data-line-bundle-id') || '');
        const bundleSlot = String(identityNode.getAttribute('data-line-bundle-slot') || '');
        const signature = `${variantId}::${bundleId}::${bundleSlot}`;
        const keys = grouped.get(signature);
        if (!keys || !keys.length) return;
        const usedIndex = counters.get(signature) || 0;
        const resolvedKey = keys[Math.min(usedIndex, keys.length - 1)];
        counters.set(signature, usedIndex + 1);
        if (!resolvedKey) return;
        lineItemEl.querySelectorAll('input[data-line-key]').forEach((input) => {
          input.setAttribute('data-line-key', resolvedKey);
        });
        lineItemEl.querySelectorAll('a[href*="/cart/change"]').forEach((link) => {
          try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('id', resolvedKey);
            link.href = url.pathname + url.search;
          } catch (e) {
            // ignore malformed URLs
          }
        });
      });
    } catch (e) {
      // silent fail to avoid blocking cart UX
    }
  }
  // Patch fetch to catch app-driven cart updates that regenerate line keys.
  if (!window.__cartKeySyncFetchPatched) {
    window.__cartKeySyncFetchPatched = true;
    const nativeFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const response = await nativeFetch(...args);
      try {
        const reqUrl = String(args?.[0]?.url || args?.[0] || '');
        if (reqUrl.includes('/cart/update.js') && reqUrl.includes('app=gfgfreegift')) {
          setTimeout(syncCartDomLineKeys, 120);
        }
      } catch (e) {
        // no-op
      }
      return response;
    };
  }
  syncCartDomLineKeys();
  document.documentElement.addEventListener('cart:refresh', () => setTimeout(syncCartDomLineKeys, 80));
  document.documentElement.addEventListener('cart:change', () => setTimeout(syncCartDomLineKeys, 80));
  // Validate required bundle selections before allowing checkout from cart drawer.
  function updateCartDrawerCheckoutValidation(cartData = null) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    const checkoutButton = cartDrawer.querySelector('button[name="checkout"]');
    if (!checkoutButton) return;
    const requiredSlotGroups = window.ASL_SLOT_KEYS.map((key) => window.ASL_SLOT_ALIASES[key]);
    const validate = (cart) => {
      const items = Array.isArray(cart?.items) ? cart.items : [];
      const mainBundleIds = new Set();
      items.forEach((item) => {
        if (item?.properties?._bundle_type === 'main_product' && item?.properties?._bundle_id) {
          mainBundleIds.add(item.properties._bundle_id);
        }
      });
      let hasIncompleteBundle = false;
      mainBundleIds.forEach((bundleId) => {
        requiredSlotGroups.forEach((slotGroup) => {
          const hasAnyInGroup = items.some((item) => {
            const props = item?.properties || {};
            if (props._bundle_id !== bundleId) return false;
            if (props._bundle_type === 'main_product') return false;
            return slotGroup.some((alias) => alias.toLowerCase() === String(props._bundle_slot || '').toLowerCase());
          });
          if (!hasAnyInGroup) {
            hasIncompleteBundle = true;
          }
        });
      });
      checkoutButton.disabled = hasIncompleteBundle;
      checkoutButton.setAttribute('aria-disabled', hasIncompleteBundle ? 'true' : 'false');
      checkoutButton.title = hasIncompleteBundle ? 'Please choose all 3 free gifts for each bundle before checkout.' : '';
    };
    if (cartData && Array.isArray(cartData.items)) {
      validate(cartData);
      return;
    }
    fetch(window.aslCartUrl('cart.js'))
      .then((response) => response.json())
      .then((cart) => validate(cart))
      .catch(() => {});
  }
  updateCartDrawerCheckoutValidation();
  document.documentElement.addEventListener('cart:refresh', () => updateCartDrawerCheckoutValidation());
  document.documentElement.addEventListener('cart:change', (event) => {
    updateCartDrawerCheckoutValidation(event.detail?.cart || null);
  });
  // ──────────────────────────────────────────────────
  // Auto-remove orphaned free gifts when main product
  // is removed from cart
  // ──────────────────────────────────────────────────
  let isCleaningBundle = false;
  document.documentElement.addEventListener('cart:change', async (event) => {
    if (isCleaningBundle) return; // prevent recursive calls
    const cart = event.detail?.cart;
    if (!cart || !cart.items) return;
    // Collect all _bundle_ids that still have a main_product in the cart
    const activeBundleIds = new Set();
    cart.items.forEach(item => {
      if (item.properties && item.properties._bundle_type === 'main_product' && item.properties._bundle_id) {
        activeBundleIds.add(item.properties._bundle_id);
      }
    });
    // Find orphaned gifts: items with a _bundle_id whose main_product is gone
    const orphanedKeys = [];
    cart.items.forEach(item => {
      if (
        item.properties &&
        item.properties._bundle_id &&
        item.properties._bundle_type !== 'main_product' &&
        !activeBundleIds.has(item.properties._bundle_id)
      ) {
        orphanedKeys.push(item.key);
      }
    });
    if (orphanedKeys.length === 0) return;
    isCleaningBundle = true;
    try {
      // Build updates object: set quantity 0 for each orphaned gift
      const updates = {};
      orphanedKeys.forEach(key => {
        updates[key] = 0;
      });
      await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.error('Error removing orphaned bundle gifts:', err);
    } finally {
      isCleaningBundle = false;
    }
  });
  // Handle duplicating bundles in the cart
  document.addEventListener('click', async function (e) {
    const cloneBtn = e.target.closest('.js-clone-bundle');
    if (!cloneBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const bundleId = cloneBtn.getAttribute('data-bundle-id');
    if (!bundleId) return;
    if (cloneBtn.disabled) return;
    cloneBtn.disabled = true;
    cloneBtn.style.opacity = '0.5';
    try {
      const response = await fetch(window.aslCartUrl('cart.js'));
      const cartData = await response.json();
      const itemsToClone = cartData.items.filter(item =>
        item.properties && item.properties._bundle_id === bundleId
      );
      if (itemsToClone.length === 0) return;
      const newBundleId = 'bundle_' + Date.now();
      
      const payloadItems = [];
      itemsToClone.forEach(item => {
        const itemSlot = item.properties._bundle_slot;
        const isSelectableSlot = window.aslIsSelectableSlot(itemSlot);
        if (!isSelectableSlot) {
          let newProperties = Object.assign({}, item.properties);
          newProperties._bundle_id = newBundleId;
          newProperties._bundle_cloned = 'true';
          
          payloadItems.push({
            id: item.variant_id,
            quantity: 1, // Add exactly 1 new instance
            properties: newProperties
          });
        }
      });
      const addResponse = await fetch(window.aslCartUrl('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: payloadItems })
      });
      if (!addResponse.ok) throw new Error('Failed to clone bundle.');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      console.error('Error cloning bundle:', error);
    } finally {
      cloneBtn.disabled = false;
      cloneBtn.style.opacity = '1';
    }
  }, true); // Use actual event capture phase to hijack UI click before Web Component!
  // ──────────────────────────────────────────────────
  // Cart Gift Swap Modal Logic
  // ──────────────────────────────────────────────────
  const openCartGiftSwapModal = function (e) {
    const swapBtn = e.target.closest('.js-cart-gift-swap');
    if (swapBtn) {
      if (cartGiftTouchState.suppressUntil && Date.now() < cartGiftTouchState.suppressUntil) {
        return;
      }
      e.preventDefault();
      const itemKey = swapBtn.getAttribute('data-item-key');
      const bundleId = swapBtn.getAttribute('data-bundle-id');
      const bundleSlot = swapBtn.getAttribute('data-bundle-slot');
      const bundleType = swapBtn.getAttribute('data-bundle-type');
      const slotKey = window.aslSlotKey(bundleSlot);
      const modal = document.getElementById('cart-gift-swap-modal');
      if (!modal) return;
      const contentEl = modal.querySelector('[data-cart-modal-content]');
      // Swapped for a clone on each open, so listeners from the last open go with it.
      let sortEl = modal.querySelector('[data-cart-modal-sort]');
      // Prevent the cart drawer from treating a click on this modal as an 'outside' click
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && !cartDrawer._patchedForGiftModal) {
        const origHide = cartDrawer.hideForOutsideClickTarget;
        cartDrawer.hideForOutsideClickTarget = function (target) {
          if (target && target.closest && target.closest('.nx-bundle-modal, #cart-gift-swap-modal, .nx-bundle-modal__btn-loading')) {
            return false;
          }
          return origHide ? origHide.call(this, target) : !this.contains(target);
        };
        cartDrawer._patchedForGiftModal = true;
      }
      // Keep track of current properties for swapping
      modal.dataset.swapKey = itemKey;
      modal.dataset.swapBundleId = bundleId;
      modal.dataset.swapBundleSlot = slotKey;
      modal.dataset.swapBundleType = bundleType;
      let products = [];
      // Gifts already in this bag's set can't be picked twice, as on the product page.
      const inSet = new Set();
      let currentProductId = null;
      const renderModalProducts = () => {
        const choice = sortEl ? sortEl.value : 'default';
        let sortedProducts = [...products];
        if (choice.indexOf('group:') === 0) {
          sortedProducts = sortedProducts.filter((product) => product.group === choice.slice(6));
        } else if (choice === 'az') {
          sortedProducts.sort((a, b) => a.title.localeCompare(b.title));
        } else if (choice === 'za') {
          sortedProducts.sort((a, b) => b.title.localeCompare(a.title));
        }
        if (!sortedProducts.length) {
          contentEl.innerHTML = '<p class="nx-bundle-modal__empty">No options currently available.</p>';
          return;
        }
        const html = sortedProducts.map((product, index) => {
          const variants = Array.isArray(product.variants) ? product.variants : [];
          if (!variants.length) return '';
          const variantId = variants[0].id;
          const oldPrice = parseFloat(product.compare_at_price_raw) > 0
            ? product.compare_at_price
            : (parseFloat(product.price_raw) > 0 ? product.price : '');
          return `
            <div class="nx-bundle-modal__card">
              ${product.image ? `<div class="nx-bundle-modal__img-wrap"><img src="${product.image}" loading="lazy" alt="${product.title}"></div>` : ''}
              <span class="nx-bundle-modal__product-title">${product.title}</span>
              <div class="nx-bundle-modal__price-row">
                <span class="nx-bundle-modal__free-price">FREE</span>
                ${oldPrice ? `<span class="nx-bundle-modal__old-price">${oldPrice}</span>` : ''}
              </div>
              ${product.id === currentProductId
                ? '<button type="button" class="nx-bundle-modal__select-btn" disabled>Your choice</button>'
                : inSet.has(product.id)
                  ? '<button type="button" class="nx-bundle-modal__select-btn" disabled>In your set</button>'
                  : `<button type="button" class="nx-bundle-modal__select-btn" data-swap-variant="${variantId}">Select</button>`}
            </div>
          `;
        }).join('');
        contentEl.innerHTML = `<div class="nx-bundle-modal__products">${html}</div>`;
      };
      if (sortEl) {
        const newSortEl = sortEl.cloneNode(true);
        sortEl.parentNode.replaceChild(newSortEl, sortEl);
        sortEl = newSortEl;
        sortEl.querySelectorAll('optgroup').forEach((group) => group.remove());
        sortEl.value = 'default';
        sortEl.addEventListener('change', renderModalProducts);
      }
      contentEl.innerHTML = '<p class="nx-bundle-modal__empty" role="status">Loading options...</p>';
      // Only the latest tap may fill the pop-up, if two loads overlap.
      const openId = (modal.aslOpenId || 0) + 1;
      modal.aslOpenId = openId;
      Promise.all([
        window.aslLoadGiftLists(),
        fetch(window.aslCartUrl('cart.js'), { cache: 'no-store' }).then((res) => res.json())
      ]).then(([lists, cart]) => {
        if (modal.aslOpenId !== openId) return;
        products = lists[slotKey] || lists[bundleSlot] || [];
        (cart.items || []).forEach((line) => {
          if (!line.properties || line.properties._bundle_id !== bundleId) return;
          if (line.key === itemKey) currentProductId = line.product_id;
          else inSet.add(line.product_id);
        });
        // A long list can be narrowed by type, as in the product page picker.
        const groupLabels = {
          fabric: 'Fabric and prints',
          pattern: 'Pattern leather',
          chain: 'Chain',
          houndstooth: 'Houndstooth',
          leather: 'Leather',
          cards: 'Card holders',
          cases: 'Sunglasses cases'
        };
        const groups = Object.keys(groupLabels).filter((group) => products.some((product) => product.group === group));
        if (sortEl && groups.length > 1) {
          const optgroup = document.createElement('optgroup');
          optgroup.label = 'Show only';
          groups.forEach((group) => {
            optgroup.appendChild(new Option(groupLabels[group], 'group:' + group));
          });
          sortEl.appendChild(optgroup);
        }
        renderModalProducts();
      }).catch((error) => {
        console.error('Swap options:', error);
        if (modal.aslOpenId !== openId) return;
        contentEl.innerHTML = '<p class="nx-bundle-modal__empty">These options did not load. Please close this and try again.</p>';
      });
      // Always move modal to very end of body so it paints above cart-drawer AND
      // any third-party iframes (Klarna etc) that append themselves to body.
      // We use a microtask so Klarna/other scripts that fire synchronously on the
      // same event tick cannot append after us.
      modal.hidden = false;
      Promise.resolve().then(() => {
        document.body.appendChild(modal);
      });
      return;
    }
  };
  document.addEventListener('click', openCartGiftSwapModal, true);
  // Start loading the choices as soon as a mouse reaches for Swap, so the pop-up is ready.
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest('.js-cart-gift-swap')) window.aslLoadGiftLists().catch(() => {});
  }, { capture: true, passive: true });
  const cartGiftTouchState = {
    startX: 0,
    startY: 0,
    startTime: 0,
    moved: false,
    suppressUntil: 0
  };
  const CART_GIFT_TAP_MOVE_THRESHOLD = 10;
  const CART_GIFT_TAP_TIME_THRESHOLD = 700;
  document.addEventListener('touchstart', function (e) {
    const target = e.target.closest('.js-cart-gift-swap');
    if (!target) return;
    window.aslLoadGiftLists().catch(() => {});
    const touch = e.touches && e.touches[0];
    if (!touch) return;
    cartGiftTouchState.startX = touch.clientX;
    cartGiftTouchState.startY = touch.clientY;
    cartGiftTouchState.startTime = Date.now();
    cartGiftTouchState.moved = false;
  }, { capture: true, passive: true });
  document.addEventListener('touchmove', function (e) {
    const target = e.target.closest('.js-cart-gift-swap');
    if (!target) return;
    const touch = e.touches && e.touches[0];
    if (!touch) return;
    const deltaX = Math.abs(touch.clientX - cartGiftTouchState.startX);
    const deltaY = Math.abs(touch.clientY - cartGiftTouchState.startY);
    if (deltaX > CART_GIFT_TAP_MOVE_THRESHOLD || deltaY > CART_GIFT_TAP_MOVE_THRESHOLD) {
      cartGiftTouchState.moved = true;
    }
  }, { capture: true, passive: true });
  document.addEventListener('touchend', function (e) {
    const target = e.target.closest('.js-cart-gift-swap');
    if (!target) return;
    const elapsed = Date.now() - cartGiftTouchState.startTime;
    if (cartGiftTouchState.moved || elapsed > CART_GIFT_TAP_TIME_THRESHOLD) {
      cartGiftTouchState.suppressUntil = Date.now() + 600;
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, { capture: true, passive: false });
  const cartGiftSwapModal = document.getElementById('cart-gift-swap-modal');
  if (cartGiftSwapModal) {
    const tapState = {
      startX: 0,
      startY: 0,
      startTime: 0,
      moved: false,
      lastTouchEndAt: 0
    };
    const TAP_MOVE_THRESHOLD = 10;
    const TAP_TIME_THRESHOLD = 700;
    // ── Scroll state management ──────────────────────────────────────────────
    // The panel itself is the scroll container (overflow-y: scroll).
    // iOS Safari blocks scroll inside position:fixed when html has overflow:hidden.
    // The theme adds html.lock (overflow:hidden) when drawer opens — remove it
    // while modal is open, restore when modal closes.
    const setCartGiftModalScrollState = (isOpen) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (isOpen) {
        // 1. Remove scroll lock so iOS Safari can scroll inside position:fixed
        document.documentElement.classList.remove('lock');
        // 2. Pause focus-trap on the cart drawer.
        //    focus-trap intercepts ALL touches on the document to keep focus
        //    inside the drawer. This blocks touchmove on our modal entirely.
        try { if (cartDrawer && cartDrawer.focusTrap) cartDrawer.focusTrap.pause(); } catch(e) {}
      } else {
        // Restore scroll lock and focus-trap for the cart drawer
        document.documentElement.classList.add('lock');
        try { if (cartDrawer && cartDrawer.focusTrap) cartDrawer.focusTrap.unpause(); } catch(e) {}
      }
    };
    // ── Touch handling ───────────────────────────────────────────────────────
    cartGiftSwapModal.addEventListener('pointerdown', function (e) {
      e.stopPropagation();
    });
    // Block scroll on the dark backdrop only — not on the panel
    cartGiftSwapModal.addEventListener('touchmove', function (e) {
      if (!e.target.closest('.nx-bundle-modal__panel')) {
        e.preventDefault();
      }
    }, { passive: false });
    // Stop panel touches bubbling up to cart drawer — passive:true so iOS scrolls freely
    const modalPanel = cartGiftSwapModal.querySelector('.nx-bundle-modal__panel');
    if (modalPanel) {
      modalPanel.addEventListener('touchstart', function (e) {
        e.stopPropagation();
        const touch = e.touches && e.touches[0];
        if (!touch) return;
        tapState.startX = touch.clientX;
        tapState.startY = touch.clientY;
        tapState.startTime = Date.now();
        tapState.moved = false;
      }, { passive: true });
      modalPanel.addEventListener('touchmove', function (e) {
        e.stopPropagation();
        const touch = e.touches && e.touches[0];
        if (!touch) return;
        const deltaX = Math.abs(touch.clientX - tapState.startX);
        const deltaY = Math.abs(touch.clientY - tapState.startY);
        if (deltaX > TAP_MOVE_THRESHOLD || deltaY > TAP_MOVE_THRESHOLD) {
          tapState.moved = true;
        }
      }, { passive: true });
      modalPanel.addEventListener('touchend', function (e) {
        e.stopPropagation();
        tapState.lastTouchEndAt = Date.now();
      }, { passive: true });
    }
    // ── Interaction handler ──────────────────────────────────────────────────
    const onCartGiftSwapModalInteract = function (e) {
      e.stopPropagation();
      // Close
      if (e.target.closest('[data-cart-modal-close]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        cartGiftSwapModal.hidden = true;
        setCartGiftModalScrollState(false);
        requestAnimationFrame(() => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            if (typeof drawer.show === 'function') drawer.show();
            else if (typeof drawer.open === 'function') drawer.open();
            else if (typeof drawer.focus === 'function') drawer.focus({ preventScroll: true });
          }
        });
        return;
      }
      // Select a swap variant
      const selectBtn = e.target.closest('[data-swap-variant]');
      if (selectBtn) {
        const now = Date.now();
        if (e.type === 'click' && tapState.lastTouchEndAt && (now - tapState.lastTouchEndAt) < 350 && tapState.moved) {
          return;
        }
        if (e.type === 'touchend') {
          const elapsed = now - tapState.startTime;
          if (tapState.moved || elapsed > TAP_TIME_THRESHOLD) {
            return;
          }
        }
        if (selectBtn.classList.contains('nx-bundle-modal__btn-loading')) return;
        e.preventDefault();
        // One swap at a time, across every option in the list
        if (cartGiftSwapModal.dataset.swapBusy === '1') return;
        cartGiftSwapModal.dataset.swapBusy = '1';
        selectBtn.classList.add('nx-bundle-modal__btn-loading');
        const newVariantId = selectBtn.getAttribute('data-swap-variant');
        const itemKey = cartGiftSwapModal.dataset.swapKey;
        const bundleId = cartGiftSwapModal.dataset.swapBundleId;
        const bundleSlot = cartGiftSwapModal.dataset.swapBundleSlot;
        const bundleType = cartGiftSwapModal.dataset.swapBundleType;
        const itemsToAdd = [{
          id: parseInt(newVariantId, 10),
          quantity: 1,
          properties: {
            '_bundle_id': bundleId,
            '_bundle_slot': window.aslSlotKey(bundleSlot),
            '_bundle_type': bundleType
          }
        }];
        // Add first, then remove: if either step fails the shopper still has a
        // gift, and the old line's key stays good for another try.
        fetch(window.aslCartUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        })
          .then(res => {
            if (!res.ok) throw new Error('Failed to add new item');
            return res.json();
          })
          .then(() => {
            if (!itemKey) return null;
            // Adding can move the discount off the old line, which gives it a new key,
            // so find it again by its variant and slot before removing it.
            return fetch(window.aslCartUrl('cart.js'), { headers: { 'Accept': 'application/json' } })
              .then(res => res.json())
              .then(cart => {
                const oldVariantId = parseInt(String(itemKey).split(':')[0], 10);
                const oldLine = cart.items.find(item => item.key === itemKey) || cart.items.find(item => (
                  item.variant_id === oldVariantId &&
                  item.properties &&
                  item.properties._bundle_id === bundleId &&
                  window.aslSlotKey(item.properties._bundle_slot) === window.aslSlotKey(bundleSlot)
                ));
                if (!oldLine) return null;
                return fetch(window.aslCartUrl('cart/change.js'), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ id: oldLine.key, quantity: 0 })
                }).then(res => {
                  if (!res.ok) throw new Error('Failed to remove old item');
                  return res.json();
                });
              });
          })
          .then(() => {
            cartGiftSwapModal.hidden = true;
            setCartGiftModalScrollState(false);
            selectBtn.classList.remove('nx-bundle-modal__btn-loading');
            setTimeout(() => {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              const drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open();
              else if (drawer && typeof drawer.show === 'function') drawer.show();
            }, 350);
          })
          .catch(error => {
            console.error('Swap Error:', error);
            selectBtn.classList.remove('nx-bundle-modal__btn-loading');
            // The old gift may already be gone, so show the cart as it really is.
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            alert('Could not swap item. Please try again.');
          })
          .finally(() => {
            delete cartGiftSwapModal.dataset.swapBusy;
          });
      }
    };
    cartGiftSwapModal.addEventListener('click', onCartGiftSwapModalInteract, true);
    cartGiftSwapModal.addEventListener('touchend', onCartGiftSwapModalInteract, { capture: true, passive: false });
    // Sync scroll state whenever hidden attribute toggles
    const observer = new MutationObserver(() => {
      const isOpen = !cartGiftSwapModal.hidden;
      setCartGiftModalScrollState(isOpen);
      // Re-assert modal is last in body on every open, even after Klarna/other
      // third-party scripts append iframes to body after us
      if (isOpen) {
        Promise.resolve().then(() => {
          if (!cartGiftSwapModal.hidden) {
            document.body.appendChild(cartGiftSwapModal);
          }
        });
      }
    });
    observer.observe(cartGiftSwapModal, { attributes: true, attributeFilter: ['hidden'] });
  }
});